export default __webpack_public_path__ + "static/media/ep12000e.a359752b.jpg";